import { useState } from 'react'
import { useToggle } from 'react-use'

export const useUserLocation = () => {
  const [userLocApproved, toggleUserLocApproved] = useToggle(true)
  const [userCoords, setUserCoords] = useState<{ lat: number; long: number }>()

  const requestUserCoords = () =>
    new Promise<{ lat: number; long: number }>((resolve, reject) => {
      if (window.navigator.geolocation) {
        window.navigator.geolocation.getCurrentPosition(
          (position) => {
            resolve({ lat: position.coords.latitude, long: position.coords.longitude })
          },
          (error) => {
            if (error.code === error.PERMISSION_DENIED) {
              toggleUserLocApproved(false)
            }
            reject(error.message)
          },
          { enableHighAccuracy: true, maximumAge: 0, timeout: 15000 },
        )
      } else {
        reject('Browser does not support geoLocation data.')
      }
    }).then((coords) => {
      setUserCoords(coords)
      return coords
    })

  return {
    requestUserCoords,
    userCoords,
    userLocApproved,
  }
}
